var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'rich-editor' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 116 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'rich-editor' });
    }
    ;
    /*event 1 on project 'com.wixpress.rich-editor has no function name set, please set one in BI Catalog.*/
    /**
    * @typedef {Object} replacePluginParams
    * @property {string} container - consumer name
    * @property {string} container_id - consumer app def id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} plugin_id - plugin id
    * @property {string} plugins_details - specification of the plugin
    * @property {string} post_id - post_id
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - version of RCE
    **/
    /**
     * Name: replace plugin. Evid: 19.
     * Event description: in case of user replace the content of the plugin (replace picture/gip/ etc).
    
     * container - Type: string. Desc: consumer name
     *
     * container_id - Type: string. Desc: consumer app def id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * plugin_id - Type: string. Desc: plugin id
     *
     * plugins_details - Type: string. Desc: specification of the plugin
     *
     * post_id - Type: string. Desc: post_id
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: version of RCE
     * @param {replacePluginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.replacePlugin = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} menuLoadParams
    * @property {string} container - consumer name
    * @property {string} container_id - consumer app def id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} content_id - external content id (based on usage)
    * @property {string} menu - more, + side menu
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - (on refresh)
    * @property {string} version - rce version
    **/
    /**
     * Name: Menu Load. Evid: 17.
     * Event description: Event for loading a menu (+, more, etc.).
    
     * container - Type: string. Desc: consumer name
     *
     * container_id - Type: string. Desc: consumer app def id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * content_id - Type: string. Desc: external content id (based on usage)
     *
     * menu - Type: string. Desc: more, + side menu
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: (on refresh)
     *
     * version - Type: string. Desc: rce version
     * @param {menuLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.menuLoad = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} addPluginParams
    * @property {string} container - blog/groups/forum etc...
    * @property {string} container_id - id of group/ forum etc
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} entry_point - side_toolbar,footer_toolbar
    * @property {string} entry_type - specification for the entry point
    * @property {string} plugin_id - plugin id
    * @property {string} plugins_details - specification of the plugin
    * @property {string} post_id - post id
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - version of RCE
    **/
    /**
     * Name: add plugin click. Evid: 2.
     * Event description: user clicked add on a plug in.
    
     * container - Type: string. Desc: blog/groups/forum etc...
     *
     * container_id - Type: string. Desc: id of group/ forum etc
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
     *
     * entry_type - Type: string. Desc: specification for the entry point
     *
     * plugin_id - Type: string. Desc: plugin id
     *
     * plugins_details - Type: string. Desc: specification of the plugin
     *
     * post_id - Type: string. Desc: post id
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: version of RCE
     * @param {addPluginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addPlugin = function (params) {
        return this.bi.log(__assign({ evid: 2 }, params));
    };
    /**
    * @typedef {Object} openEditorSuccessParams
    * @property {string} container - consumer name
    * @property {string} container_id - consumer app def id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} content_id - external content id (based on usage)
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - (on refresh)
    * @property {string} version - rce version
    **/
    /**
     * Name: open editor success. Evid: 9.
     * Event description: successfully opened rce.
    
     * container - Type: string. Desc: consumer name
     *
     * container_id - Type: string. Desc: consumer app def id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * content_id - Type: string. Desc: external content id (based on usage)
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: (on refresh)
     *
     * version - Type: string. Desc: rce version
     * @param {openEditorSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.openEditorSuccess = function (params) {
        return this.bi.log(__assign({ evid: 9 }, params));
    };
    /**
    * @typedef {Object} uploadMediaTryParams
    * @property {string} container - []
    * @property {string} container_id - []
    * @property {string} correlationId - to connect with success event
    * @property {number} fileSize - []
    * @property {string} mediaType - video/image/etc.
    * @property {string} plugin_id - []
    * @property {GUID} rce_session_id - []
    * @property {string} type - not in use
    * @property {string} version - rce versoin
    **/
    /**
     * Name: Upload media try. Evid: 13.
     * Event description: upload media in RCE started (per file) Not from media manager.
    
     * container - Type: string. Desc: []
     *
     * container_id - Type: string. Desc: []
     *
     * correlationId - Type: string. Desc: to connect with success event
     *
     * fileSize - Type: numeric. Desc: []
     *
     * mediaType - Type: string. Desc: video/image/etc.
     *
     * plugin_id - Type: string. Desc: []
     *
     * rce_session_id - Type: guid. Desc: []
     *
     * type - Type: string. Desc: not in use
     *
     * version - Type: string. Desc: rce versoin
     * @param {uploadMediaTryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.uploadMediaTry = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    /**
    * @typedef {Object} changePluginParams
    * @property {string} category - category of change (alignment/size/settings...)
    * @property {string} container - blog/groups...
    * @property {string} container_id - null
    * @property {string} container_platform - null
    * @property {string} container_usage - null
    * @property {string} origin - toolbar/sidebar/ else
    * @property {string} plugin_id - plugin
    * @property {string} plugins_details - null
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - null
    * @property {string} value - value changed to (center, right...)
    * @property {string} version - version . of rce
    **/
    /**
     * Name: change plugin. Evid: 3.
     * Event description: user changed plugin setting.
    
     * category - Type: string. Desc: category of change (alignment/size/settings...)
     *
     * container - Type: string. Desc: blog/groups...
     *
     * container_id - Type: string.
     *
     * container_platform - Type: string.
     *
     * container_usage - Type: string.
     *
     * origin - Type: string. Desc: toolbar/sidebar/ else
     *
     * plugin_id - Type: string. Desc: plugin
     *
     * plugins_details - Type: string.
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid.
     *
     * value - Type: string. Desc: value changed to (center, right...)
     *
     * version - Type: string. Desc: version . of rce
     * @param {changePluginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changePlugin = function (params) {
        return this.bi.log(__assign({ evid: 3 }, params));
    };
    /**
    * @typedef {Object} oaGetPostContentParams
    * @property {string} container - blog/forum etc
    * @property {string} container_id - id of group / forum etc
    * @property {string} container_platform - null
    * @property {string} container_usage - null
    * @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
    * @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - RCE version
    **/
    /**
     * Name: OA get post content. Evid: 7.
     * Event description: sent when consumer requests post content from RCE in OneApp.
    
     * container - Type: string. Desc: blog/forum etc
     *
     * container_id - Type: string. Desc: id of group / forum etc
     *
     * container_platform - Type: string.
     *
     * container_usage - Type: string.
     *
     * plugins_count - Type: string. Desc: JSON containing {plugin_id: num of plugins}
     *
     * plugins_details - Type: string. Desc: JSON containing an array of dictionaries (each dictionary holds a plugin's details)
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: RCE version
     * @param {oaGetPostContentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oaGetPostContent = function (params) {
        return this.bi.log(__assign({ evid: 7 }, params));
    };
    /**
    * @typedef {Object} addPluginStepParams
    * @property {string} container - blog/groups/forum etc...
    * @property {string} container_id - id of group/ forum etc
    * @property {string} entry_point - side_toolbar,footer_toolbar
    * @property {string} entry_type - specification for the entry point
    * @property {string} plugin_id - plugin id
    * @property {string} plugins_details - specification of the plugin
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} step - []
    * @property {string} version - version of RCE
    **/
    /**
     * Name: add plugin step. Evid: 11.
     * Event description: Steps between clicking on the plugin and adding it on stage.
    
     * container - Type: string. Desc: blog/groups/forum etc...
     *
     * container_id - Type: string. Desc: id of group/ forum etc
     *
     * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
     *
     * entry_type - Type: string. Desc: specification for the entry point
     *
     * plugin_id - Type: string. Desc: plugin id
     *
     * plugins_details - Type: string. Desc: specification of the plugin
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * step - Type: string. Desc: []
     *
     * version - Type: string. Desc: version of RCE
     * @param {addPluginStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addPluginStep = function (params) {
        return this.bi.log(__assign({ evid: 11 }, params));
    };
    /**
    * @typedef {Object} publishPostParams
    * @property {string} container - blog/groups...
    * @property {string} container_id - id of group/ forum etc
    * @property {string} container_platform - null
    * @property {string} container_usage - null
    * @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
    * @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
    * @property {string} post_id - post id
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - version of RCE
    **/
    /**
     * Name: publish post success. Evid: 5.
     * Event description: user published his post - currently Desktop only.
    
     * container - Type: string. Desc: blog/groups...
     *
     * container_id - Type: string. Desc: id of group/ forum etc
     *
     * container_platform - Type: string.
     *
     * container_usage - Type: string.
     *
     * plugins_count - Type: string. Desc: JSON containing {plugin_id: num of plugins}
     *
     * plugins_details - Type: string. Desc: JSON containing an array of dictionaries (each dictionary holds a plugin's details)
     *
     * post_id - Type: string. Desc: post id
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: version of RCE
     * @param {publishPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.publishPost = function (params) {
        return this.bi.log(__assign({ evid: 5 }, params));
    };
    /**
    * @typedef {Object} openEditorParams
    * @property {string} container - gorups/blog..
    * @property {string} container_id - gorup_id..
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - []
    * @property {string} version - rce version
    **/
    /**
     * Name: open editor click. Evid: 10.
     * Event description: user/UoU opened the rc editor.
    
     * container - Type: string. Desc: gorups/blog..
     *
     * container_id - Type: string. Desc: gorup_id..
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: []
     *
     * version - Type: string. Desc: rce version
     * @param {openEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.openEditor = function (params) {
        return this.bi.log(__assign({ evid: 10 }, params));
    };
    /**
    * @typedef {Object} pluginViewedParams
    * @property {string} container - consumer name
    * @property {string} container_id - consumer app def id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} content_id - external content id (based on usage)
    * @property {string} menu - more, + side menu
    * @property {string} plugin_viewed - name of the plugin
    * @property {GUID} rce_session_id - (on refresh)
    * @property {string} version - rce version
    **/
    /**
     * Name: Plugin viewed. Evid: 18.
     * Event description: A plugin was viewed by the user.
    
     * container - Type: string. Desc: consumer name
     *
     * container_id - Type: string. Desc: consumer app def id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * content_id - Type: string. Desc: external content id (based on usage)
     *
     * menu - Type: string. Desc: more, + side menu
     *
     * plugin_viewed - Type: string. Desc: name of the plugin
     *
     * rce_session_id - Type: guid. Desc: (on refresh)
     *
     * version - Type: string. Desc: rce version
     * @param {pluginViewedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.pluginViewed = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} contentAddedParams
    * @property {string} contact_id - external content id (based on usage)
    * @property {string} container - consumer name
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_type - .
    * @property {string} container_usage - Post / Feed / Comment
    * @property {number} editing_time - in seconds
    * @property {number} paragraph_count - .
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - (on refresh)
    * @property {string} version - rce version
    * @property {number} word_count - .
    **/
    /**
     * Name: Content added. Evid: 16.
     * Event description: An even for adding text component.
    
     * contact_id - Type: string. Desc: external content id (based on usage)
     *
     * container - Type: string. Desc: consumer name
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_type - Type: string. Desc: .
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * editing_time - Type: numeric. Desc: in seconds
     *
     * paragraph_count - Type: numeric. Desc: .
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: (on refresh)
     *
     * version - Type: string. Desc: rce version
     *
     * word_count - Type: numeric. Desc: .
     * @param {contentAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contentAdded = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} deletePluginParams
    * @property {string} container - blog/...
    * @property {string} container_id - id of group/ forum etc
    * @property {string} container_platform - null
    * @property {string} container_usage - null
    * @property {string} plugin_id - []
    * @property {string} plugins_details - specification of the plugin
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - version of RCE
    **/
    /**
     * Name: delete plugin click. Evid: 4.
     * Event description: user deleted a plugin.
    
     * container - Type: string. Desc: blog/...
     *
     * container_id - Type: string. Desc: id of group/ forum etc
     *
     * container_platform - Type: string.
     *
     * container_usage - Type: string.
     *
     * plugin_id - Type: string. Desc: []
     *
     * plugins_details - Type: string. Desc: specification of the plugin
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: version of RCE
     * @param {deletePluginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.deletePlugin = function (params) {
        return this.bi.log(__assign({ evid: 4 }, params));
    };
    /**
    * @typedef {Object} viewerActionParams
    * @property {string} action_name - image_link/expand_image etc.
    * @property {string} container - groups/blog etc
    * @property {string} container_id - app_def_id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} plugin_id - []
    * @property {string} plugins_details - null
    * @property {string} post_id - null
    * @property {string} value - additional information
    **/
    /**
     * Name: viewer action. Evid: 8.
     * Event description: UoU did some action in the RCE viewer.
    
     * action_name - Type: string. Desc: image_link/expand_image etc.
     *
     * container - Type: string. Desc: groups/blog etc
     *
     * container_id - Type: string. Desc: app_def_id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * plugin_id - Type: string. Desc: []
     *
     * plugins_details - Type: string.
     *
     * post_id - Type: string.
     *
     * value - Type: string. Desc: additional information
     * @param {viewerActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewerAction = function (params) {
        return this.bi.log(__assign({ evid: 8 }, params));
    };
    /**
    * @typedef {Object} viewerLoadedParams
    * @property {string} container - consumer name
    * @property {string} container_id - consumer app def id
    * @property {string} container_platform - Livesite / BM / OneApp
    * @property {string} container_usage - Post / Feed / Comment
    * @property {string} content_id - external content id (based on usage)
    * @property {string} post_id - null
    * @property {boolean} preview - preview/full
    * @property {GUID} rce_session_id - (on refresh)
    * @property {string} version - rce version
    **/
    /**
     * Name: Viewer Loaded. Evid: 15.
     * Event description: RCV is loaded.
    
     * container - Type: string. Desc: consumer name
     *
     * container_id - Type: string. Desc: consumer app def id
     *
     * container_platform - Type: string. Desc: Livesite / BM / OneApp
     *
     * container_usage - Type: string. Desc: Post / Feed / Comment
     *
     * content_id - Type: string. Desc: external content id (based on usage)
     *
     * post_id - Type: string.
     *
     * preview - Type: bool. Desc: preview/full
     *
     * rce_session_id - Type: guid. Desc: (on refresh)
     *
     * version - Type: string. Desc: rce version
     * @param {viewerLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewerLoaded = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} addPluginSuccessParams
    * @property {string} container - blog/forum/groups...
    * @property {string} container_id - id of group/ forum etc
    * @property {string} container_platform - null
    * @property {string} container_usage - null
    * @property {string} entry_point - side_toolbar,footer_toolbar
    * @property {string} entry_type - specification for the entry point
    * @property {string} plugin_id - plugin_id
    * @property {string} plugins_details - specification of the plugin
    * @property {string} post_id - null
    * @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
    * @property {string} version - version of RCE
    **/
    /**
     * Name: add plugin success. Evid: 6.
     * Event description: add plugin successfully.
    
     * container - Type: string. Desc: blog/forum/groups...
     *
     * container_id - Type: string. Desc: id of group/ forum etc
     *
     * container_platform - Type: string.
     *
     * container_usage - Type: string.
     *
     * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
     *
     * entry_type - Type: string. Desc: specification for the entry point
     *
     * plugin_id - Type: string. Desc: plugin_id
     *
     * plugins_details - Type: string. Desc: specification of the plugin
     *
     * post_id - Type: string.
     *
     * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
     *
     * version - Type: string. Desc: version of RCE
     * @param {addPluginSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addPluginSuccess = function (params) {
        return this.bi.log(__assign({ evid: 6 }, params));
    };
    /**
    * @typedef {Object} uploadMediaFinishedParams
    * @property {string} container - []
    * @property {string} container_id - []
    * @property {string} correlationId - to connect with success event
    * @property {number} duration - in ms
    * @property {string} errorReason - []
    * @property {number} fileSize - []
    * @property {boolean} isSuccess - []
    * @property {string} mediaType - video/image/etc.
    * @property {string} plugin_id - []
    * @property {GUID} rce_session_id - []
    * @property {string} type - not in use
    * @property {string} version - rce versoin
    **/
    /**
     * Name: Upload media finished. Evid: 14.
     * Event description: upload media in RCE finished (per file) Not from media manager.
    
     * container - Type: string. Desc: []
     *
     * container_id - Type: string. Desc: []
     *
     * correlationId - Type: string. Desc: to connect with success event
     *
     * duration - Type: numeric. Desc: in ms
     *
     * errorReason - Type: string. Desc: []
     *
     * fileSize - Type: numeric. Desc: []
     *
     * isSuccess - Type: bool. Desc: []
     *
     * mediaType - Type: string. Desc: video/image/etc.
     *
     * plugin_id - Type: string. Desc: []
     *
     * rce_session_id - Type: guid. Desc: []
     *
     * type - Type: string. Desc: not in use
     *
     * version - Type: string. Desc: rce versoin
     * @param {uploadMediaFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.uploadMediaFinished = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 116,
        endpoint: 'rich-editor'
    };
}
//# sourceMappingURL=index.js.map